import script from "./MenuParceriasComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./MenuParceriasComponent.vue?vue&type=script&setup=true&lang=js"

import "./MenuParceriasComponent.vue?vue&type=style&index=0&id=5a67f1dd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5a67f1dd"]])

export default __exports__